<template>
  <div class="register">
    <div class="register_school_icon">
      <img src="../assets/imgs/loginSchoolIcon.png" alt="" width="100%" />
    </div>
    <div class="register_systmeName">北师大实验国际部简历系统</div>
    <div class="register_form">
      <div class="register_form_title">注册</div>
      <div class="register_form_back" @click="goLogin">登录</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
        label-position="left"
        class="demo-ruleForm"
      >
        <el-form-item label="学生姓名：" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
          <div class="rule_tips">提示：请填写学生的姓名，非家长姓名</div>
        </el-form-item>


        <el-form-item label="手机号：" prop="mobilePhone">
          <el-input v-model="ruleForm.mobilePhone"></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input type="password" v-model="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item label="再次输入密码：" prop="checkPwd">
          <el-input type="password" v-model="ruleForm.checkPwd"></el-input>
        </el-form-item>
        <!-- <el-form-item label="教育ID" prop="eduId">
                <el-input v-model="ruleForm.eduId"></el-input>
            </el-form-item> -->
        <el-form-item label="验证码：" prop="validateCode" class="validateCode">
          <el-input v-model="ruleForm.validateCode"></el-input>
          <div class="codeImg" @click="getImgCode">
            <img :src="imageVerifyUrl" alt="" width="100%" height="100%" />
          </div>
        </el-form-item>
        <el-form-item
          label="短信验证码："
          prop="mobilePhoneValidateCode"
          class="messageValidateCode"
        >
          <el-input v-model="ruleForm.mobilePhoneValidateCode"></el-input>
          <el-button
            type="primary"
            @click="getMobileCode"
            class="purple"
            :class="identityClass"
            >{{ identityText }}</el-button
          >
        </el-form-item>
        <el-form-item class="operate">
          <el-button
            type="primary"
            @click="register('ruleForm')"
            class="purple"
            :disabled="registerDisable"
            >注册</el-button
          >
        </el-form-item>
      </el-form>
      <!-- <div class="tip">在确认填写正确的情况下，如果因为教育ID重复无法注册，请联系学校</div> -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Form, FormItem, Input, Button, Message } from "element-ui";
Vue.use(Form).use(FormItem).use(Input).use(Button);
export default {
  name: "register",
  data() {
    // 自定义校验密码输入
    const validateModPass1 = (rule, value, callback) => {
      if (this.ruleForm.checkPwd.trim() !== "") {
        this.$refs.ruleForm.validateField("checkPwd");
      }
      callback();
    };
    // 自定义校验确认密码输入
    const validateModPass2 = (rule, value, callback) => {
      if (
        value.trim() !== this.ruleForm.password.trim() &&
        this.ruleForm.checkPwd.trim()
      ) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        name: "",
        eduId: "",
        password: "",
        checkPwd: "",
        validateCode: "",
        mobilePhone: "",
        mobilePhoneValidateCode: "",
      },
      rules: {
        name: [{ required: true, message: "请输入学生姓名", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validateModPass1, trigger: "blur" },
          { min: 8, message: "请输入8位数及以上的密码", trigger: "blur" },
        ],
        checkPwd: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validateModPass2, trigger: "blur" },
        ],
        mobilePhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确的手机号", trigger: "blur" },
        ],
        validateCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        mobilePhoneValidateCode: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
      },
      imageVerifyToken: "",
      imageVerifyUrl: "",
      identityText: "获取验证码",
      // 验证码60s倒计时
      countdown: 60,
      // 获取验证码按钮的class
      identityClass: "identityInitial",
      registerDisable: false,
    };
  },
  methods: {
    // 注册
    register(form) {
      const that = this;
      this.$refs[form].validate((valid) => {
        if (valid) {
          that.registerDisable = true;
          that.ruleForm.validateToken = that.imageVerifyToken;
          that.ruleForm.eduId = that.ruleForm.mobilePhone;
          that.$axios
            .post(
              "/galaxy/baoming/api/v1/huaxia/applicant/regedit",
              that.ruleForm
            )
            .then((result) => {
              const res = result.data;
              if (
                result.code === "1000000" &&
                res &&
                JSON.stringify(res) !== "{}"
              ) {
                Message({
                  type: "success",
                  message: "注册成功,即将跳转",
                  duration: 800,
                  onClose() {
                    // that.$router.push(
                    //   {
                    //     name: 'PersonalMessage',
                    //     query: {
                    //       applicationId: res.applicationId || '',
                    //       applicantToken: res.applicantToken,
                    //       batchState: res.batchState,
                    //       fillEnable: res.fillEnable ? 1 : 0
                    //     }
                    //   }
                    // )

                    that.$router.push({ path: "/login" });
                  },
                });
              } else {
                that.registerDisable = false;
                that.getImgCode();
              }
            })
            .catch((err) => {
              console.log(err);
              that.registerDisable = false;
            });
        }
      });
    },
    // 返回登录
    goLogin() {
      this.$router.push({
        name: "Login",
      });
    },
    // 获取图形验证码
    getImgCode() {
      this.$axios
        .get(`/galaxy/baoming/api/v1/huaxia/applicant/generateValidateCode`)
        .then((result) => {
          const res = result.data;
          if (
            result.code === "1000000" &&
            res &&
            JSON.stringify(res) !== "{}"
          ) {
            this.imageVerifyToken = res.imageVerifyToken;
            this.imageVerifyUrl = res.url;
          } else {
            this.imageVerifyToken = "";
            this.imageVerifyUrl = "";
          }
        });
    },
    // 获取短信验证码
    getMobileCode() {
      const that = this;
      if (that.ruleForm.validateCode) {
        if (that.countdown === 60) {
          that.$axios
            .post(
              "/galaxy/baoming/api/v1/huaxia/applicant/sendMobilePhoneValidateCode",
              {
                imageTokenCode: that.imageVerifyToken,
                imageValidateCode: that.ruleForm.validateCode,
                mobilePhone: that.ruleForm.mobilePhone,
              }
            )
            .then((result) => {
              const res = result.data;
              if (result.code === "1000000" && res) {
                Message({
                  type: "success",
                  message: "验证码已发送，请注意查收",
                  duration: 800,
                });
                that.identityClass = "identityFinal";
                const interval = setInterval(() => {
                  if (that.countdown === 0) {
                    that.identityText = "重新获取";
                    that.countdown = 60;
                    that.identityClass = "identityInitial";
                    clearInterval(interval);
                  } else {
                    that.countdown--;
                    that.identityText = that.countdown + "s";
                  }
                }, 1000);
              } else {
                that.getImgCode();
              }
            });
        } else {
          Message({
            type: "warning",
            message: "不能重复点击！",
            duration: 800,
          });
        }
      } else {
        Message({
          type: "warning",
          message: "请先填写图形验证码",
          duration: 800,
        });
      }
    },
  },
  created() {
    this.getImgCode();
  },
};
</script>

<style lang="scss" scoped>
.register {
  width: 100vw;
  min-height: 100vh;
  background: #edf3f7;
  padding-top: 4%;
  padding-bottom: 30px;
  .register_school_icon {
    width: 30%;
    margin: 0 auto 20px;
  }
  .register_systmeName {
    text-align: center;
    color: #474747;
    font-size: 32px;
  }
  .register_form {
    width: 486px;
    margin: 50px auto 0;
    background-color: #fff;
    padding: 20px 36px;
    border-radius: 10px;
    position: relative;
    .register_form_title {
      font-size: 24px;
      color: #353535;
      margin-bottom: 24px;
    }
    .register_form_back {
      position: absolute;
      top: 30px;
      right: 36px;
      color: #1890ff;
      cursor: pointer;
      font-size: 16px;
    }
  }
}
</style>
<style lang="scss">
.register_form {
  .rule_tips {
    line-height:12px;
    margin-top: 5px;;

    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);

  }
  .el-form-item__label {
    color: rgba(0, 0, 0, 0.85);
  }
  .el-input {
    height: 32px;
    line-height: 32px;
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
  .messageValidateCode {
    .el-form-item__content {
    }
    .el-button {
      float: right;
      width: 102px;
      height: 32px;
      text-align: center;
      padding: 0;
    }
    .el-input {
      float: left;
      width: 174px;
      .el-input__inner {
        width: 174px;
      }
    }
  }
  .validateCode {
    .codeImg {
      width: 94px;
      height: 32px;
      background-color: rgba(226, 134, 148, 1);
      cursor: pointer;
      float: right;
    }
    .el-input {
      float: left;
      width: 183px;
      .el-input__inner {
        width: 183px;
      }
    }
  }
  .operate {
    text-align: center;
    .el-form-item__content {
      margin-left: 0 !important;
    }
    .el-button {
      width: 198px;
    }
    .el-button + .el-button {
      margin-left: 16px;
    }
  }
  .identityFinal {
    border-color: #37bfff !important;
    color: #fff !important;
    background-color: #37bfff !important;
  }
  .purple {
    background-color: #1890ff !important;
    border-color: #1890ff !important;
    &:hover {
      background-color: #1890ff;
      border-color: #1890ff;
      color: #fff;
    }
  }
  .default:hover {
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
  }
}
</style>
